import React, { useState } from 'react'
import {
  Button,
  Col,
  Flex,
  Form,
  Modal,
  notification,
  Row,
  Space,
  Typography,
  Upload,
  UploadFile,
  UploadProps,
} from 'antd'
import { handleApiError } from '@/utils/api.tsx'
import { AntdForm } from '@/common/components/AntdForm'
import { AntdFormRules } from '@/common/components/AntdForm/rules.tsx'
import { useImportFxRateHistoriesMutation } from '@/features/portal-configuration/portal-configuration.api.ts'

type FxRateHistoryImportModalProps = {
  onCancel: () => void
}

type FormValues = {
  excelFiles: UploadFile[]
}

const FxRateHistoryImportForm: React.FC<FxRateHistoryImportModalProps> = ({ onCancel }) => {
  const [form] = Form.useForm()
  const [excelImport, { isLoading }] = useImportFxRateHistoriesMutation()

  const onFinish = async (data: FormValues) => {
    const excelFile = data.excelFiles[0]
    const result = await excelImport({
      excelFile: excelFile.originFileObj as unknown as File,
    })
    if ('data' in result) {
      notification.success({ message: 'Update successfully' })
      handleCancel()
    } else {
      handleApiError(result.error)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onCancel()
  }

  const uploadButtonProps: UploadProps = {
    maxCount: 1,
    showUploadList: true,
    beforeUpload: () => false,
    multiple: false,
    accept: '.xlsx',
  }


  return (
    <Form
      layout="vertical"
      scrollToFirstError
      form={form}
      onFinish={onFinish}
    >
      <Row gutter={16}>
        <Col span={8}>
          <AntdForm.Item
            name="excelFiles"
            rules={[AntdFormRules.required]}
            valuePropName="fileList"
            getValueFromEvent={e => e.fileList}
          >
            <Upload {...uploadButtonProps}>
              <Button htmlType="button">Select Excel File (.xlsx)</Button>
            </Upload>
          </AntdForm.Item>
        </Col>
      </Row>
      <Flex justify="flex-end" align="center">
        <Space>
          <Button htmlType="button" onClick={handleCancel} danger>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Confirm
          </Button>
        </Space>
      </Flex>
    </Form>
  )
}

export const FxRateHistoryImportModal: React.FC = () => {
  const [openExcelImportModal, setOpenExcelImportModal] = useState(false)

  return (
    <>
      <Button htmlType="button" type="primary" onClick={() => setOpenExcelImportModal(true)}>Excel Import</Button>
      <Modal
        title="Update FX Rate History"
        width={1000}
        destroyOnHidden
        maskClosable={false}
        open={openExcelImportModal}
        onCancel={() => setOpenExcelImportModal(false)}
        footer={null}
      >
        <Typography.Paragraph>Please select the FX rate excel from Finance Team</Typography.Paragraph>
        <FxRateHistoryImportForm onCancel={() => setOpenExcelImportModal(false)} />
      </Modal>
    </>
  )
}